<template>
    <div>
        <el-select v-if="this.caller!='filterbox'" v-model="optedindex" filterable remote placeholder="Please enter a keyword"
            :remote-method="remoteMethod">
            <el-option v-for="(item, index) in options" :key="item.index" :label="item.label" :value="index">
            </el-option>
        </el-select>

        <!-- <div  v-if="this.caller=='filterbox'"><el-button type="primary" @click="apisearch">Api Search</el-button></div> -->

        <el-form :model="queryset">
            <el-form-item v-for="keyobj in apiobj.querykey" :key="keyobj.key">
                <el-input placeholder="Please input" v-model="queryset[keyobj.key]" @keyup.enter.native="apisearch">
                    <template slot="prepend">{{ keyobj.label }}</template>
                </el-input>
            </el-form-item>
        </el-form>

        <el-button v-if="this.caller!='filterbox'" type="primary" @click="fetchjson">Remote提取json</el-button>


    </div>
</template>

<script>

export default {
    props: ["caller"],
    data() {
        return {
            options: [{ label: "未选", querykey: [] }],
            queryset: {},
            optedindex: 0,
            list: [],
            loading: false

        }
    },
    computed: {
        apiobj() {
            return this.options[this.optedindex]
        }
    },

    watch: {

    },
    mounted() {
        //如果collection指定了apiurl
        let apisource=this.$store.state.collection.apisource
        if(apisource){
            this.remoteMethod("^"+apisource+"$")
        }
        else{this.remoteMethod("")}
        
    },
    methods: {
        apisearch() {
            this.$store.commit("setsearchmodel", "apisearch");
            this.$store.commit("setapiparams", this.queryset );
            this.$store.commit("setpage", 1);
            this.$axios.fetchdata();
        },
        remoteMethod(q) {
            this.$axios
                .post(url + "filter", {
                    collection: "api_json",
                    fdata: { label: q },
                    page: 1,
                    log: false//不记录
                })
                .then((res) => {
                    if (res.data.doc.length > 0) { this.options = res.data.doc }

                    // console.log(this.options)
                })
        },

        fetchjson() {
            // let urlinfo = this.options[this.optedindex]
            let params = Object.assign(this.queryset, this.apiobj.defaultkey)

            this.$axios({
                method: "post",
                url: url + "apijsonfetch",
                data: { url: this.apiobj.url, params: params, resultkey: this.apiobj.resultkey },
                config: { headers: { "Content-Type": "application/json" } },
            }).then((res) => {
                this.$emit("jsondone", JSON.stringify(res.data))

            });





        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/exceltodb/defineddb_json_api.vue